module.exports = __webpack_public_path__ + "static/media/KCC_CSE3-OA_Volunteer_Application_Form.e9f80636.pdf";